import { trackUsage } from '@creditsights/api-ui-web';

export const enum TrackUsageEvents {
  RISK_CALCULATOR_CALCULATE_CLICKED = 'RISK_CALCULATOR_CALCULATE_CLICKED',
  RISK_CALCULATOR_RESET_CLICKED = 'RISK_CALCULATOR_RESET_CLICKED',
}

export const trackRiskCalculatorButtonClick = (
  companyId: string,
  companyName: string,
  rpSectorModel: string,
  event: TrackUsageEvents
): void => {
  trackUsage(event, [
    {
      key: 'companyId',
      value: companyId,
    },
    {
      key: 'companyName',
      value: companyName,
    },
    {
      key: 'rpSectorModel',
      value: rpSectorModel,
    },
  ]);
};
